/*
 * LYOLEY order options.
 * Shows a thumbnail of the artwork the customer has selected, so they can see
 * the right file is attached before adding to cart. Preview only, the file
 * itself is submitted by the native product form as a line item property.
 */
(function () {
  if (window.lyoleyOrderOptionsReady) return;
  window.lyoleyOrderOptionsReady = true;

  var MAX_BYTES = 20 * 1024 * 1024;

  function formatSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return Math.round(bytes / 1024) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
  }

  function clearPreview(box) {
    var img = box.querySelector('img[data-object-url]');
    if (img) URL.revokeObjectURL(img.src);
    box.innerHTML = '';
    box.hidden = true;
  }

  function render(input) {
    var field = input.closest('.lyoley-order-options__field');
    if (!field) return;

    var box = field.querySelector('.lyoley-order-options__preview');
    if (!box) {
      box = document.createElement('div');
      box.className = 'lyoley-order-options__preview';
      box.hidden = true;
      field.appendChild(box);
    }

    clearPreview(box);

    var file = input.files && input.files[0];
    if (!file) return;

    var thumb = document.createElement('div');
    thumb.className = 'lyoley-order-options__thumb';

    if (file.type && file.type.indexOf('image/') === 0) {
      var img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.setAttribute('data-object-url', 'true');
      img.alt = 'Preview of ' + file.name;
      thumb.appendChild(img);
    } else {
      var badge = document.createElement('span');
      badge.className = 'lyoley-order-options__filetype';
      badge.textContent = (file.name.split('.').pop() || 'file').toUpperCase();
      thumb.appendChild(badge);
    }

    var meta = document.createElement('div');
    meta.className = 'lyoley-order-options__meta';

    var name = document.createElement('span');
    name.className = 'lyoley-order-options__filename';
    name.textContent = file.name;

    var size = document.createElement('span');
    size.className = 'lyoley-order-options__filesize';
    size.textContent = formatSize(file.size);

    meta.appendChild(name);
    meta.appendChild(size);

    if (file.size > MAX_BYTES) {
      var warn = document.createElement('span');
      warn.className = 'lyoley-order-options__warning';
      warn.textContent = 'This file is over 20 MB and will not upload. Please send it to us separately.';
      meta.appendChild(warn);
    }

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'lyoley-order-options__remove';
    remove.textContent = 'Remove';
    meta.appendChild(remove);

    box.appendChild(thumb);
    box.appendChild(meta);
    box.hidden = false;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('lyoley-order-options__file')) {
      render(target);
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('lyoley-order-options__remove')) return;
    var field = target.closest('.lyoley-order-options__field');
    if (!field) return;
    var input = field.querySelector('.lyoley-order-options__file');
    var box = field.querySelector('.lyoley-order-options__preview');
    if (input) input.value = '';
    if (box) clearPreview(box);
    if (input) input.focus();
  });
})();
